import { isFeatureEnabled } from '@lumapps/features';
import { isUserAllowed, isInstanceSuperAdmin, isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { ANALYTICS_PERMISSIONS } from '../permissions';

export const isExtendedAnalyticsEnabled = isFeatureEnabled('extended-lumapps-analytics');
export const isPauseAnalyticsCollectionEnabled = isFeatureEnabled('disable-analytics-collection');
export const hasDiscoverBetaEnabled = isFeatureEnabled('discover-beta');

export const isAnalyticsAllowed = isUserAllowed(ANALYTICS_PERMISSIONS.ANALYTICS_READ);

/** Selector that allows only global admin to see analytics. Should be used for platform level dashboard */
export const canViewPlatformAnalytics = createSelector(
    isSuperAdmin,
    isExtendedAnalyticsEnabled,
    (isSuperAdmin = false, isAnalyticEnabled = false) => {
        return isSuperAdmin && isAnalyticEnabled;
    },
);

/** Selector that allows global admin, instance admin and read analytics to see analytics. Should be used for instance level dashboard */
export const canViewInstanceAnalytics = createSelector(
    isInstanceSuperAdmin,
    isExtendedAnalyticsEnabled,
    isAnalyticsAllowed,
    (instanceAdmin = false, isAnalyticEnabled = false, isAnalyticsReadAllowed = false) => {
        const hasAccess = instanceAdmin || isAnalyticsReadAllowed;

        return hasAccess && isAnalyticEnabled;
    },
);
